/**
 * Category Tabs
 * -------------
 * Progressive enhancement only. The tab bar is fully functional server-rendered
 * markup (plain links, active state resolved in Liquid); this script just adds
 * scroll affordances for the horizontally scrollable strip.
 */
(function () {
  'use strict';

  var SCROLLER = '[data-hct-scroller]';

  function updateFades(scroller) {
    var list = scroller.querySelector('.header-category-tabs__list');
    if (!list) return;

    var maxScroll = list.scrollWidth - list.clientWidth;
    // Sub-pixel layout rounding can leave 1px of phantom scroll.
    var atStart = list.scrollLeft <= 1;
    var atEnd = list.scrollLeft >= maxScroll - 1;

    scroller.classList.toggle('is-overflowing-start', maxScroll > 1 && !atStart);
    scroller.classList.toggle('is-overflowing-end', maxScroll > 1 && !atEnd);
  }

  function scrollActiveIntoView(scroller) {
    var list = scroller.querySelector('.header-category-tabs__list');
    var active = scroller.querySelector('.header-category-tabs__item.is-active');
    if (!list || !active) return;
    if (list.scrollWidth <= list.clientWidth) return;

    // Centre the active tab without scrolling the page itself, which
    // `scrollIntoView` would do inside a sticky header.
    var target = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
    list.scrollLeft = Math.max(0, target);
  }

  function init(scroller) {
    if (scroller.dataset.hctInit === 'true') return;
    scroller.dataset.hctInit = 'true';

    var list = scroller.querySelector('.header-category-tabs__list');
    if (!list) return;

    scrollActiveIntoView(scroller);
    updateFades(scroller);

    list.addEventListener('scroll', function () {
      updateFades(scroller);
    }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        updateFades(scroller);
      }).observe(list);
    } else {
      window.addEventListener('resize', function () {
        updateFades(scroller);
      }, { passive: true });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SCROLLER).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
